import { defineComponent as _defineComponent } from 'vue'
import { useMutation } from '@tanstack/vue-query';
import { Convidados, IPresenca } from 'common/types/Presenca';
import { TIPOS_DE_CONVIDADOS } from '@/../common/shareds/sharedPresenca';
import { defineComponent, ref, watch } from 'vue';
import PresencaService from '@/services/PresencaService';


export default /*#__PURE__*/_defineComponent({
  __name: 'DialogoDeConvidados',
  props: {
    value: null
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as { value: IPresenca };

defineComponent({})




const opcoes = TIPOS_DE_CONVIDADOS

const convidados = ref(criarConvidados())
const mostra = ref(false)

watch(mostra, (novo, antigo) => {
    if (novo && !antigo) convidados.value = criarConvidados(props.value)
})

const { mutate: salvarConvidados, isPending: salvando } = useMutation({
    mutationFn: () => PresencaService.patch(props.value._id, {
        convidados: convidados.value,
    }),
    onSuccess(presenca) {
        emit('input', presenca)
        mostra.value = false
    },
})

function criarConvidados(presenca?: IPresenca): Convidados {
    return presenca?.convidados 
        ? { ...presenca.convidados }
        : {
            adultos: 0,
            criancas: 0
        }
}

return { __sfc: true,props, emit, opcoes, convidados, mostra, salvarConvidados, salvando, criarConvidados }
}

})